// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-players-to-team__container{
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
    margin-top: var(--space-and-half);
    justify-content: space-between;
}

.add-players-to-team__shield{
    background: var(--white-color);
    flex: 0 0 auto;
    margin-top: var(--space-x2);
    width: calc( calc( var(--space) * 11) + var(--space-quarter));
    height: calc( calc( var(--space) * 11) + var(--space-quarter));
    border-radius: 4px;
    text-align: left;
}

.add-players-to-team__shield img{
    width: calc(var(--space-x3) + var(--space-half));
    border-radius: 4px;
}

.add-players-to-team__shield .icon-team-2-64{
    font-size: calc(var(--space-x3) + var(--space-half));
    color: var(--mid-gray-color);
}

/*.add-players-to-team__shield span.icon-team-2-64{
    position: relative;
    top: var(--space-x2);
}*/

.add-players-to-team__team-name.baloa-subtitle-1{
    color: var(--basic-gray-color) !important;
    text-transform: uppercase;
    margin-top: var(--space);
}
.add-players-to-team__team-teamname, .add-players-to-team__team-gender, .add-players-to-team__team-category{
    margin-top: var(--space-quarter);
}

.add-players-to-team__form__content{
   display: flex;
    padding-left: var(--space-x3);
    padding-right: var(--space-x3);
    padding-top: var(--space-x2);   
    
    width: 100%;
}

.add-players-to-team__header{
    display: flex;
    justify-content: space-between;
    flex-basis: 100%;
}

.add-players-to-team__header-subtitle.baloa-headline-4{
    color: var(--primary-dark-color) !important;
    font-size: calc( var(--space-x2) + var(--space-quarter)) !important;
}

.add-players-to-team__search {
   margin-top: 0;
   max-width: 250px;
}

.add-players-to-team__members-list{
   margin-bottom: var(--space-x3);
   padding-left: var(--space-x3);
    padding-right: var(--space-x3);

}

.add-players-to-team__bulk-add-members-button{
   display: flex;
    width:100%;
    height: 100%;
   padding-top:calc(var(--space-half)*4.5);
    align-items: flex-start;
    justify-content: flex-end;
    padding-bottom: calc(var(--space-half)*3);
}

.add-players-to-team__bulk-add-members-button__button{
    max-width: 200px;
    border: 2px solid var(--secondary-color);
    margin-left: calc(var(--space-x2) + var(--space-half));

    --disabled-sb-bg-color: transparent;
    --disabled-sb-font-color: #D8E7E0;
    --hover-sb-bg-color: #D9FFEA;
    --focused-sb-bg-color: #ABFFD0;
    --active-sb-bg-color: #4BFF9B;    
}

.button.primary-button.add-players-to-team__submit {
   min-width: 200px;
   height: calc( var(--space-x2) + var(--space-half));
   justify-content: center;
   margin-bottom: var(--space);
   display: flex;
   margin-left: auto;
   margin-right: var(--space-x2);   
}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-add-players-to-team/LeagueAddPlayersToTeamComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,2BAA2B;IAC3B,6DAA6D;IAC7D,8DAA8D;IAC9D,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,kBAAkB;AACtB;;AAEA;IACI,oDAAoD;IACpD,4BAA4B;AAChC;;AAEA;;;EAGE;;AAEF;IACI,yCAAyC;IACzC,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,gCAAgC;AACpC;;AAEA;GACG,aAAa;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;;IAE5B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,mEAAmE;AACvE;;AAEA;GACG,aAAa;GACb,gBAAgB;AACnB;;AAEA;GACG,8BAA8B;GAC9B,6BAA6B;IAC5B,8BAA8B;;AAElC;;AAEA;GACG,aAAa;IACZ,UAAU;IACV,YAAY;GACb,uCAAuC;IACtC,uBAAuB;IACvB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,wCAAwC;IACxC,sDAAsD;;IAEtD,mCAAmC;IACnC,iCAAiC;IACjC,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;GACG,gBAAgB;GAChB,kDAAkD;GAClD,uBAAuB;GACvB,2BAA2B;GAC3B,aAAa;GACb,iBAAiB;GACjB,6BAA6B;AAChC","sourcesContent":[".add-players-to-team__container{\n    display: flex;\n    align-content: flex-start;\n    flex-wrap: wrap;\n    margin-top: var(--space-and-half);\n    justify-content: space-between;\n}\n\n.add-players-to-team__shield{\n    background: var(--white-color);\n    flex: 0 0 auto;\n    margin-top: var(--space-x2);\n    width: calc( calc( var(--space) * 11) + var(--space-quarter));\n    height: calc( calc( var(--space) * 11) + var(--space-quarter));\n    border-radius: 4px;\n    text-align: left;\n}\n\n.add-players-to-team__shield img{\n    width: calc(var(--space-x3) + var(--space-half));\n    border-radius: 4px;\n}\n\n.add-players-to-team__shield .icon-team-2-64{\n    font-size: calc(var(--space-x3) + var(--space-half));\n    color: var(--mid-gray-color);\n}\n\n/*.add-players-to-team__shield span.icon-team-2-64{\n    position: relative;\n    top: var(--space-x2);\n}*/\n\n.add-players-to-team__team-name.baloa-subtitle-1{\n    color: var(--basic-gray-color) !important;\n    text-transform: uppercase;\n    margin-top: var(--space);\n}\n.add-players-to-team__team-teamname, .add-players-to-team__team-gender, .add-players-to-team__team-category{\n    margin-top: var(--space-quarter);\n}\n\n.add-players-to-team__form__content{\n   display: flex;\n    padding-left: var(--space-x3);\n    padding-right: var(--space-x3);\n    padding-top: var(--space-x2);   \n    \n    width: 100%;\n}\n\n.add-players-to-team__header{\n    display: flex;\n    justify-content: space-between;\n    flex-basis: 100%;\n}\n\n.add-players-to-team__header-subtitle.baloa-headline-4{\n    color: var(--primary-dark-color) !important;\n    font-size: calc( var(--space-x2) + var(--space-quarter)) !important;\n}\n\n.add-players-to-team__search {\n   margin-top: 0;\n   max-width: 250px;\n}\n\n.add-players-to-team__members-list{\n   margin-bottom: var(--space-x3);\n   padding-left: var(--space-x3);\n    padding-right: var(--space-x3);\n\n}\n\n.add-players-to-team__bulk-add-members-button{\n   display: flex;\n    width:100%;\n    height: 100%;\n   padding-top:calc(var(--space-half)*4.5);\n    align-items: flex-start;\n    justify-content: flex-end;\n    padding-bottom: calc(var(--space-half)*3);\n}\n\n.add-players-to-team__bulk-add-members-button__button{\n    max-width: 200px;\n    border: 2px solid var(--secondary-color);\n    margin-left: calc(var(--space-x2) + var(--space-half));\n\n    --disabled-sb-bg-color: transparent;\n    --disabled-sb-font-color: #D8E7E0;\n    --hover-sb-bg-color: #D9FFEA;\n    --focused-sb-bg-color: #ABFFD0;\n    --active-sb-bg-color: #4BFF9B;    \n}\n\n.button.primary-button.add-players-to-team__submit {\n   min-width: 200px;\n   height: calc( var(--space-x2) + var(--space-half));\n   justify-content: center;\n   margin-bottom: var(--space);\n   display: flex;\n   margin-left: auto;\n   margin-right: var(--space-x2);   \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
